export default "__VITE_ASSET__Dgog34wU__"